import { Image, Spin } from 'antd'
import { FileImage, ScanSearch } from 'lucide-react'
import { cn } from '@/utils/index.ts'

export function LicenseDocumentPreview({
  src,
  title,
  large = false,
  loading = false
}: {
  src?: string
  title: string
  large?: boolean
  loading?: boolean
}) {
  return (
    <div
      className={cn(
        'flex items-center justify-center overflow-hidden rounded-lg border border-slate-200 bg-slate-50 dark:border-slate-700 dark:bg-slate-900',
        large ? 'h-64 sm:h-80' : 'h-48'
      )}
    >
      {loading ? (
        <Spin aria-label="正在加载证件" />
      ) : src ? (
        <Image
          src={src}
          alt={title}
          width="100%"
          height="100%"
          classNames={{ root: 'h-full! w-full!', image: 'h-full! w-full! object-contain p-3' }}
          preview={{
            cover: (
              <span className="flex items-center gap-2">
                <ScanSearch aria-hidden size={18} />
                查看原图
              </span>
            )
          }}
        />
      ) : (
        <div className="flex flex-col items-center gap-2 px-4 text-center text-slate-400">
          <FileImage aria-hidden size={28} strokeWidth={1.5} />
          <span className="text-sm">尚未提供{title}</span>
        </div>
      )}
    </div>
  )
}
